import React from 'react';
import Button from '../../../../components/Buttons/Button';

import { useAccountContext } from '../Data/accountContext';
import FormBase from '../FormBase';
import FormPDFApplication from '../Common/PDFForm/FormPDFApplication';

import TextField from '../../../../components/Textfields/TextField';
import Text from '../../../../components/Typography/Text';
import { ReactComponent as SignatureGraphic } from '../../../../assets/graphics/sign-graphic.svg';
import ESignatureModal from '../../../../components/Modals/ESignatureModal';
import { useAppContext } from '../../../../context/AppContext';
import { GeneratePDF } from '../Common/PDFForm/GeneratePDF';
import { pdf } from '@react-pdf/renderer';
import { attachFiles, deleteOnboardingFile } from '../../../../services/CommonService';
import { signRegistration } from '../../../../services/RegistrationService';

export default function FormSubmit() {
  const { account, setAccount, dynamicDisclosures, setIsLoading, disableUpdate } =
    useAccountContext();
  const correspondentData = useAppContext();
  const document = GeneratePDF(account, dynamicDisclosures, correspondentData);

  const [open, setOpen] = React.useState(false);

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleSave = async () => {
    setIsLoading(true);
    const docToOnboard = { ...document };
    const result = await pdf(docToOnboard).toBlob();

    const file = new File(
      [result],
      account.primaryOwner.firstName +
        ' ' +
        account.primaryOwner.lastName +
        ' Onboarding.pdf',
      {
        type: result.type,
      }
    );
    await deleteOnboardingFile(account.accountId, [file]);
    await attachFiles(account.accountId, 'ClientAccount', [file], 'onboarding');
    await signRegistration(account);

    setIsLoading(false);
  };

  return (
    <FormBase
      name="submit"
      header="Submit Your Application"
      subHeader="You have completed all the necessary steps"
      save={handleSave}
      pdfForm={
        <FormPDFApplication
          document={document}
          account={account}
          dynamicDisclosures={dynamicDisclosures}
        />
      }
    >
      <form className="signature-form-w" autoComplete="off">
        {account.imgSignature ? (
          <div className="grd-row">
            <div className="grd-cell">
              <TextField
                disabled
                mt={20}
                max={50}
                name="primaryApplicantSignature"
                label="Primary Applicant E-Signature"
                placeholder="Primary Applicant Signature"
                type="text"
                value={account.imgSignature}
              />
            </div>
            {account.accountType === 'J' ? (
              <div className="grd-cell">
                <TextField
                  disabled
                  mt={20}
                  max={50}
                  name="coApplicantSignature"
                  label="Co-Applicant E-Signature"
                  placeholder="Co-Applicant Signature"
                  type="text"
                  value={account.coApplicantSignature}
                />
              </div>
            ) : null}
          </div>
        ) : (
          <SignatureGraphic
            style={{
              maxWidth: 270,
              maxHeight: 270,
              margin: '0 auto',
              display: 'block',
            }}
          />
        )}
        <Button
          mt={true}
          label="Sign E-Signature"
          onClick={handleOpenModal}
          disabled={disableUpdate}
        />
        <Text
          mt={30}
          variant="body1"
          label="I have read, understood and accepted the terms and conditions provided during
                                the account opening process; I will comply with all terms of the Client Agreement
                                (including the pre-dispute arbitration clauses at the end of the Agreement) and all
                                other agreements and disclosures provided to me above; and I understand and agree
                                that my electronic signature is equivalent to my handwritten signature."
        />
        <ESignatureModal
          modalTitle="E-Signature"
          content={
            <div>
              <TextField
                required={true}
                mt={20}
                max={50}
                name="imgSignature"
                label="Primary applicant signature here."
                placeholder="Primary Applicant Signature"
                type="text"
                value={account.imgSignature}
                onChange={(e) => {
                  const input = e.currentTarget.name ? e.currentTarget : e.target;
                  setAccount({
                    ...account,
                    imgSignature: input.value,
                  });
                }}
              />
              {account.accountType === 'J' && (
                <TextField
                  required={true}
                  mt={20}
                  max={50}
                  name="coApplicantSignature"
                  label="Co-applicant signature here."
                  placeholder="Co-Applicant Signature"
                  type="text"
                  value={account.coApplicantSignature}
                  onChange={(e) => {
                    const input = e.currentTarget.name ? e.currentTarget : e.target;
                    setAccount({
                      ...account,
                      coApplicantSignature: input.value,
                    });
                  }}
                />
              )}
            </div>
          }
          open={open}
          onClose={handleCloseModal}
        />
      </form>
    </FormBase>
  );
}
